<template>
  <div class="my-published-homework">
    <div class="homework-list" v-bitmap="getHomeworkListResult">
      <homeworkItem :homeworkInfo="item" :style="{
        'animation-duration': `${index <= 10 ? (index + 1) * 0.3 : 0.3}s`,
      }" class="homework-item" v-for="(item, index) in homeworkList" :key="item.id" />
    </div>
    <pagination :pageSize="pageSize" :total="total" @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange"></pagination>
  </div>
</template>

<script>
import homeworkItem from "@/components/homework-item/homeworkItem";
export default {
  props: {
    total: {
      type: [Number, String]
    },
    homeworkList: {
      type: [Object, Array]
    },
    getHomeworkListResult: {
      type: [Number, String]
    },
  },
  data() {
    return {
      // total: 0,
      // homeworkList: [],
      // getHomeworkListResult: "nullData",
      pageSize: 10,
    };
  },
  components: {
    homeworkItem,
  },
  // created() {
  //   this.getMyPublishHomeworkList();
  // },
  methods: {
    currentPageNumChange(e) {
      this.$emit("currentMyPublishHomeworkList", e);
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.$emit("currentMyPublishHomeworkListPageSize", pageSize);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./myPublishedHomework.scss";
</style>